import axios from "axios";
import * as XLSX from "xlsx";
import Papa from "papaparse";
import config from "../../../../config/config";
import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { Link, useParams } from "react-router-dom";
import Sidebar from "../../../Dashboard/Sidebar/Sidebar";
import Loader from "../../../../components/Loader/Loader";
import { toastError, toastSuccess } from "../../../../common/Toast";
import {
  ALREADY_EXIST,
  ERROR_MESSAGE,
  SUCCESS_MESSAGE,
} from "../../../../common/Constant";

const ExcelImport = (props) => {
  let fields, excelReadData;
  let defaultStatus = 3;
  const paramObject = useParams();
  const Id = localStorage.getItem("ID");
  const token = localStorage.getItem("Token");
  const [loading, setLoading] = useState(false);
  const locationId = localStorage.getItem("Location");

  const downloadExcel = () => {
    const inventoryExcelColumnName = [
      { Field: "Item Id/Item Number/Product ID" },
      { Field: "Count" },
    ];
    console.log("inventoryExcelColumnName ==> ", inventoryExcelColumnName);

    let dataFields = inventoryExcelColumnName.map((obj) => obj.Field);
    console.log("dataFields ==> ", dataFields);

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet([]);
    // XLSX.utils.sheet_add_aoa(ws, data);
    XLSX.utils.sheet_add_aoa(ws, [dataFields]);
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    const binaryData = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const blob = new Blob([binaryData], { type: "application/octet-stream" });
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = "import_count_inventory.xlsx";
    link.click();
  };

  const handleFile = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();

    reader.onload = (e) => {
      const binaryData = e.target.result;
      const workbook = XLSX.read(binaryData, { type: "binary" });
      const sheet = workbook.Sheets[workbook.SheetNames[0]];
      const rawData = XLSX.utils.sheet_to_csv(sheet);

      const processedData = Papa.parse(rawData, {
        header: true,
        transformHeader: (header) => header.replace(/\s+|-|\/|#/g, ""),
      }).data;
      excelReadData = processedData;

      console.log("excelReadData: ", excelReadData);

      const rows = rawData.split("\n");
      const data = rows.map((row) => row.split(","));
      fields = data[0];
    };

    reader.readAsBinaryString(file);
  };

  const handleSubmit = () => {
    // setLoading(true);
    const changeCountInventoryArray = excelReadData.map((obj, index) => ({
      Id: index + 1,
      ItemId: obj.ItemIdItemNumberProductID,
      Counts: obj.Count,
    }));

    let CountInventoryExcel = changeCountInventoryArray.filter(function (
      countinventoryexcel
    ) {
      return countinventoryexcel.ItemIdItemNumberProductID !== "";
    });

    const countinventoryexcelobj = {};
    countinventoryexcelobj.importDataXML = CountInventoryExcel;
    let countinventoryexceljsonstring = JSON.stringify(countinventoryexcelobj);

    console.log(
      "countinventoryexceljsonstring ==> ",
      countinventoryexceljsonstring
    );
    axios
      .post(
        `${config.itemsBaseUrl}/items/countitemsinventory`,
        {
          xmlImportData: countinventoryexceljsonstring,
          loginUserId: Id,
          inventoryCountId: paramObject.id,
          locationId: locationId,
          status: defaultStatus,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS" && res.data.ResponseID == 1) {
          // setSuccessMessageHideShow(true);
          toastSuccess(SUCCESS_MESSAGE);
        } else {
          // setSuccessMessageHideShow(false);
          toastError(ERROR_MESSAGE);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log("err ==> ", err);
        setLoading(false);
      });
  };

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="page-title">
              <h3>Count Inventory</h3>
              <ul className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/items">Items</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/item-count-invetory">Count Inventory</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to={`/new-inventory-count/${paramObject.id}`}>
                    New Inventory Count
                  </Link>
                </li>
                <li className="breadcrumb-item active">Excel Import</li>
              </ul>
            </div>
          </div>
          <div className="card">
            <div className="card-header">
              <h6 className="fw-bold">Mass Import Data From Excel Sheet</h6>
            </div>
            <div className="card-body">
              <div className="d-flex flex-row">
                {/* Step 1 */}
                <div className="p-4">
                  <div className="d-flex flex-row">
                    <div className="p-2">
                      <h4 className="fw-bold mb-2">Step 1:</h4>
                    </div>
                    <div className="p-2 mb-2">
                      <h4> Download file for inventory count</h4>
                      <button
                        className="btn btn-primary"
                        onClick={downloadExcel}
                      >
                        Download Excel Template for Inventory Count
                      </button>
                    </div>
                  </div>
                </div>
                {/* Step 2 */}
                <div className="p-4">
                  <div className="d-flex flex-row">
                    <div className="p-2">
                      <h4 className="fw-bold mb-2">Step 2:</h4>
                    </div>
                    <div className="p-2 mb-2">
                      <h4>Import count file</h4>
                      {/* <div className="row"> */}
                      <input
                        type="file"
                        className="form-control"
                        accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                        onChange={handleFile}
                      />
                      {/* </div> */}
                    </div>
                  </div>
                </div>
                {/* Step 3 */}
                <div className="p-4">
                  <div className="d-flex flex-row">
                    <div className="p-2">
                      <h4 className="fw-bold mb-2">Step 3:</h4>
                    </div>
                    <div className="p-2 mb-2">
                      <h4>Final Submit</h4>
                      {/* <div className="row"> */}
                      <button
                        className="btn btn-primary"
                        onClick={handleSubmit}
                      >
                        Submit
                      </button>
                      {/* </div> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ExcelImport;
